var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"SSClick"}},[_c('div',{attrs:{"id":"fixTop"}},[_vm._v(" ลุ้นดื่ม เอส ฟรี! ")]),_c('div',{staticClass:"main_content px-3",style:({ paddingTop: _vm.fixTop + 'px' }),attrs:{"id":"main_content"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }